/**
 * 后端和前端的文案 key 不一致，这里做个转换
 */
export const ERROR_MESSAGE_MAP: {
  [key: string]: string;
} = {
  WRONG_ACCOUNT_OR_PASSWORD: 'request.login.wrong',
  USER_NOT_EXISTS: 'request.user.notExists',
  USER_NOT_LOGIN: 'request.user.notLogin',
  MIN_REQ_EXCEEDS_LIMIT: 'request.limit.perMinute',
  FAILED_TO_SEND_MAIL: 'request.user.sendMailFailed',
};
